var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteTrianglePost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 147,
    viewBox: "0 0 151 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151 0V49.491L50.8392 147H0L151 0Z",
    fill: "#3E0292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteTrianglePost);
export default __webpack_public_path__ + "static/media/completeTrianglePost.d6fa34f153b51d1a9e348c7ab31a81ff.svg";
export { ForwardRef as ReactComponent };